
export const TradeDetailControls = "tfTradeDetailControls";

export function tradeDetailControls() {
    return {
        template,
        transclude: true,
        bindings: {
            trade: "<"
        },
        controller: () => {},
        controllerAs: "ctrl"
    };
}

const template = `
    <div class="panel-footer" ng-class="ctrl.trade.quantity < 0 ? 'sell' : 'buyTicket'">
        <div class="row">
            <h4 class="mt-0" ng-if="ctrl.trade.quantity > 0">Buying</h4>
            <h4 class="mt-0" ng-if="ctrl.trade.quantity == null || ctrl.trade.quantity === 0">Enter Quantity</h4>
            <h4 class="mt-0" ng-if="ctrl.trade.quantity < 0">Selling</h4>
        </div>
        <ng-transclude></ng-transclude>
    </div>
`;
